import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import AboutPage from "./components/About";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Map from "./components/Location";
import ScrollToTop from "./components/ScrollToTop";
import UnskippablePopup from "./components/Popup";
import Deli from "./components/departments/Deli";
import Liquor from "./components/departments/Liquor";
import Meat from "./components/departments/Meat";
import Produce from "./components/departments/Produce";
import Kosher from "./components/departments/Kosher";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <UnskippablePopup/>
      <Header />
      <Routes>
        <Route path="/about" element={<AboutPage />} />
        <Route path="/" element={<App />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/locate" element={<Map />} />

        <Route path = '/departments/deli' element = {<Deli/>}/>
         <Route path = '/departments/liquor' element = {<Liquor/>}/>
          <Route path = '/departments/meat' element = {<Meat/>}/>
           <Route path = '/departments/produce' element = {<Produce/>}/>
           <Route path = '/departments/kosher' element = {<Kosher/>}/>

      </Routes>
      <Footer />
      <Outlet />
    </BrowserRouter>
  </React.StrictMode>
);
